export const BASE_OFFER_CHECKOUT_URL = 'https://www.manualeslistos.com/cart/62833054318922:1';
export const PREMIUM_OFFER_CHECKOUT_URL = 'https://www.manualeslistos.com/cart/62833061069130:1';
